import script from "./ReferralPortalResources.vue?vue&type=script&setup=true&lang=js"
export * from "./ReferralPortalResources.vue?vue&type=script&setup=true&lang=js"

import "./ReferralPortalResources.vue?vue&type=style&index=0&id=021c10c8&scoped=true&lang=css"

import exportComponent from "/trc/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-021c10c8"]])

export default __exports__